export const getUrlParamsString = (urlParams?: object) => {
    if (!urlParams) {
        return '';
    }
    // the URLSearchParams needs to be used to ensure that we get ?param=a&param=b instead of ?param[]=[a,b]
    const urlSearchParams = new URLSearchParams();
    Object.entries(urlParams).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((item) => urlSearchParams.append(key, item));
        } else if (value) {
            urlSearchParams.append(key, value);
        }
    });
    const urlParamsString = urlSearchParams.toString();
    return urlParamsString.length > 0 ? `?${urlParamsString}` : '';
};

export const isAssetTreeSelected = () => {
    const currentUrl = new URL(window.location.href);
    return currentUrl.searchParams.get('is_asset_tree_selected') === 'true';
};

export const removeUndefinedOrEmptyArrayAttributes = <T extends Record<string, unknown>>(input: T): T => {
    Object.keys(input).forEach((key) => {
        const value = input[key];
        const isEmptyArray = Array.isArray(value) && value.length === 0;
        const isNullish = value === undefined || value === null;
        if (isNullish || isEmptyArray) {
            delete input[key];
        }
    });
    return input;
};
